import type { Locale } from 'date-fns';
import { enUS, ta } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

import { DEFAULT_LANGUAGE, isSupportedLanguage, type LanguageCode } from './languages';

const DATE_LOCALES: Record<LanguageCode, Locale> = { en: enUS, ta };

export function dateLocaleFor(language: string | undefined): Locale {
  return DATE_LOCALES[isSupportedLanguage(language) ? language : DEFAULT_LANGUAGE];
}

export function useDateLocale(): Locale {
  const { i18n } = useTranslation();
  return dateLocaleFor(i18n.resolvedLanguage);
}
